module.exports = "<div class=\"weui_panel\" :class=\"{'weui_panel_access': access}\">\n  <slot></slot>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/panel/panel.vue
 ** module id = 148
 ** module chunks = 0
 **/